import { render, staticRenderFns } from "./RequestCustomerView.vue?vue&type=template&id=4b7e7b07&scoped=true&"
import script from "./RequestCustomerView.vue?vue&type=script&lang=js&"
export * from "./RequestCustomerView.vue?vue&type=script&lang=js&"
import style0 from "./RequestCustomerView.vue?vue&type=style&index=0&id=4b7e7b07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e7b07",
  null
  
)

export default component.exports